import Vue from 'vue';
import '../../element-variables.scss';
import '../assets/element-theme-mpp/index.css';
import {Button, Col, Container, Row, Select, Form, Input, RadioButton, RadioGroup, Switch, Rate, Dialog, Alert, Checkbox, Loading} from 'element-ui';

import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
locale.use(lang);

Vue.use(Button);
Vue.use(Select);
Vue.use(Row);
Vue.use(Col);
Vue.use(Container);
Vue.use(Form);
Vue.use(Input);
Vue.use(RadioButton);
Vue.use(RadioGroup);
Vue.use(Switch);
Vue.use(Rate);
Vue.use(Dialog);
Vue.use(Alert);
Vue.use(Checkbox);
Vue.use(Loading);



/*
*
* Babel Config Example Below when using an custom element theme modification
* as generated as per this link:
* http://element.eleme.io/2.0/#/en-US/component/custom-theme#update-scss-variables-in-your-project
*
* */

/* Babel Example - start
module.exports = {
  "presets": [
    "@vue/app"
  ],
  "plugins": [
    [
      "component",
      {
        "libraryName": "element-ui",
        "styleLibraryName": "../../../src/assets/element-theme-mpp" <--- This one is starting in the node_modules/element-ui/lib/ directory and not in the root of the app
        "styleLibraryName": "element-theme-mpp" <--- This one needs the generated theme folder to be copied into node_modules/element-ui/lib/ directory
        "styleLibraryName": "element-theme-mpp" <--- This one needs the generated theme folder to be copied into node_modules/element-ui/lib/ directory
        "~/src/assets/element-theme-mpp" <--- NOT WORKING
      }
    ]
  ]
}

 */
